// /* eslint-disable prettier/prettier */
// import { PATHS } from './_PATHS'
// import { useTranslation } from 'react-i18next'
// // import MainLayout from 'layout/MainLayout'
// import SubLayout from 'layout/SubLayout'
// import RoomPage from 'pages/RoomPage'
// import HomePage from 'pages/HomePage'
// import ShopPage from 'pages/ShopPage'
// import PrizePage from 'pages/PrizePage'
// import RankPage from 'pages/RankPage'
// import FriendPage from 'pages/FriendPage'
// import MorePage from 'pages/MorePage'
// import ProfilePage from 'pages/ProfilePage'
// import LoginPassMobile from 'pages/LoginPassMobile'
// import LoginOTPMobile from 'pages/LoginOTPMobile'
// import OTPConfirmMobile from 'pages/OTPConfirmMobile'
// import PlayRoomPage from 'pages/PlayRoomPage'
// import RoomPageLayout from 'layout/RoomPageLayout'
// import { useMediaQuery, mediaQueryPoint } from 'utils/hooks'
// import LoginOTPModal from 'components/Modal/LoginOTPModal'
// import OTPConfirmModal from 'components/Modal/OTPConfirmModal'
// import MenuMobile from 'pages/ProfileMobile/MenuMobile'
// import UserInfoMobile from 'pages/ProfileMobile/UserInfoMobile'
// import SelectAvaMobile from 'pages/ProfileMobile/SelectAvaMobile'
// import GiftHistMobile from 'pages/ProfileMobile/GiftHistMobile'
// import InvitationMobile from 'pages/ProfileMobile/InvitationMobile'
// import IntroduceMobile from 'pages/ProfileMobile/IntroduceMobile'
// import ChangePassMobile from 'pages/ProfileMobile/ChangePassMobile'
// import SettingMobile from 'pages/ProfileMobile/SettingMobile'
// import ChangeInfoMobile from 'pages/ProfileMobile/ChangeInfoMobile'
// import ErrorPage from 'layout/ErrorPage'
// import MaintainPage from 'layout/MaintainPage'
// import FriendMobile from 'pages/FriendMobile'
// import RankMobile from 'pages/RankMobile'
// import { getUserinfo } from 'utils/localStorage'
// import { Navigate, useLocation } from 'react-router-dom'
// import SettingPage from 'pages/SettingPage'
// import EventWater from 'pages/Event/EventWater'
// import ResultEventWater from 'pages/Event/ResultEventWater'
// import EventBoatRacing from 'pages/Event/EventBoatRacing'
// import ResultEventBoatRacing from 'pages/Event/ResultEventBoatRacing'
// import EventBunpimay from 'pages/Event/EventBunpimay'
// import EventBoatRacingT10 from 'pages/Event/EventBoatRacingT10'
// import HomeNew from 'pages/HomeNew'
// import RankPageNew from 'pages/RankPageNew'
// import LuckySpin from 'pages/LuckySpin/LuckySpin'

// const RequireAuth = ({ children }) => {
// 	const userInfo = getUserinfo();
// 	const location = useLocation();
// 	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
// 	return userInfo ? (
// 		children
// 	) : (
// 		<Navigate to={isMobileMD ? PATHS.LOGIN_PASS_MOBILE : PATHS.HOME_PAGE} replace state={{ path: location.pathname }}></Navigate>
// 	)
// }

// export function RouteList() {
// 	const { t } = useTranslation()
// 	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)

// 	// TODO: Router transition animation

// 	return [
// 		{
// 			element: <SubLayout />,
// 			children:
// 				[
// 					// { path: PATHS.HOME_PAGE, element: <HomePage /> },
// 					{ path: PATHS.HOME_PAGE, element: <HomeNew /> },
// 					{ path: PATHS.EVENT_WATER_PAGE, element: <EventWater /> },
// 					{ path: PATHS.RESULT_EVENT_WATER_PAGE, element: <ResultEventWater /> },
// 					{ path: PATHS.EVENT_BOAT_RACING_PAGE, element: <EventBoatRacing /> },
// 					{ path: PATHS.RESULT_EVENT_BOAT_RACING_PAGE, element: <ResultEventBoatRacing /> },
// 					{ path: PATHS.BUNPIMAY_PAGE_HOME, element: <EventBunpimay /> },
// 					// { path: PATHS.SHOP_PAGE, element: <ShopPage /> },
// 					// { path: PATHS.RANK_PAGE, element: isMobileMD ? <RankMobile /> : <RankPage /> },
// 					{ path: PATHS.RANK_PAGE, element: <RankPageNew /> },
// 					{ path: PATHS.LUCKY_SPIN, element: <LuckySpin /> },
// 					...[isMobileMD ? {} : { path: PATHS.FRIEND_PAGE, element: <RequireAuth><FriendPage /></RequireAuth> }],
// 					{ path: PATHS.MORE_PAGE, element: <MorePage /> },
// 					{ element: <LoginOTPModal /> },
// 					{ element: <OTPConfirmModal /> },
// 					{ path: PATHS.EVENT_BOAT_RACING_PAGE_T10, element: <EventBoatRacingT10 /> },
// 					{
// 						element: <RoomPageLayout />,
// 						children: [
// 							...[
// 								isMobileMD
// 									? {}
// 									: {
// 										path: PATHS.ROOM_PAGE,
// 										element: <RoomPage />,
// 									},
// 								isMobileMD
// 									? {}
// 									: {
// 										path: PATHS.PLAYROOM_PAGE,
// 										element: <PlayRoomPage />,
// 									},
// 							],
// 						],
// 					},
// 					{
// 						path: PATHS.PROFILE_PAGE,
// 						element: isMobileMD ? <RequireAuth><MenuMobile /></RequireAuth> : <RequireAuth><ProfilePage /></RequireAuth>,
// 					},
// 					{
// 						path: PATHS.MAINTAIN_PAGE,
// 						element: <MaintainPage />,
// 					},
// 					{
// 						path: PATHS.UNDEFINED_PAGE,
// 						element: <ErrorPage />,
// 					},
// 					{
// 						path: PATHS.SETTING_PAGE,
// 						element: <SettingPage />,
// 					},

// 				],
// 		},
// 		{
// 			element: <SubLayout />,
// 			children:
// 				[
// 					{
// 						path: PATHS.LOGIN_PASS_MOBILE,
// 						element: <LoginPassMobile title={t('modal.login.title')} />,
// 					},
// 					{
// 						path: PATHS.LOGIN_OTP_MOBILE,
// 						element: <LoginOTPMobile title={t('modal.login.title_OTP')} />,
// 					},
// 					{
// 						path: PATHS.OTP_MOBILE,
// 						element: <OTPConfirmMobile title={t('modal.login.title_OTP')} />,
// 					},
// 					{
// 						element: <RoomPageLayout />,
// 						children: [
// 							{
// 								path: PATHS.ROOM_PAGE,
// 								element: <RoomPage />,
// 							},
// 							{
// 								path: PATHS.PLAYROOM_PAGE,
// 								element: <PlayRoomPage title={t('room.playroom.title')} />,
// 							},
// 						],
// 					},
// 					{
// 						path: PATHS.MY_ACCOUNT,
// 						element: <RequireAuth><UserInfoMobile title={t('mobile.my_acc.title')} /></RequireAuth>,
// 					},
// 					{
// 						path: PATHS.SELECT_AVA,
// 						element: <RequireAuth><SelectAvaMobile title={t('mobile.select_ava')} /></RequireAuth>,
// 					},
// 					{
// 						path: PATHS.GIFT_HIST,
// 						element: <RequireAuth><GiftHistMobile title={t('mobile.gift_hist.title')} /></RequireAuth>,
// 					},
// 					{
// 						path: PATHS.INVITATION,
// 						element: <RequireAuth><InvitationMobile title={t('mobile.invitation.title')} /></RequireAuth>,
// 					},
// 					{
// 						path: PATHS.INTRODUCE,
// 						element: <RequireAuth><IntroduceMobile title={t('mobile.introduce')} /></RequireAuth>,
// 					},
// 					{
// 						path: PATHS.CHANGE_PASS,
// 						element: <RequireAuth><ChangePassMobile title={t('mobile.change_pass.title')} /></RequireAuth>,
// 					},
// 					{
// 						path: PATHS.SETTING,
// 						element: <RequireAuth><SettingMobile title={t('mobile.setting.title')} /></RequireAuth>,
// 					},
// 					{
// 						path: PATHS.CHANGE_INFO,
// 						element: <RequireAuth><ChangeInfoMobile title={t('mobile.change_info.title')} /></RequireAuth>,
// 					},
// 					{ path: PATHS.FRIEND_PAGE, element: <RequireAuth><FriendMobile title={t('friendpage.friend')} /></RequireAuth> },
// 					{
// 						path: PATHS.MAINTAIN_PAGE,
// 						element: <MaintainPage />,
// 					},
// 					{
// 						path: PATHS.UNDEFINED_PAGE,
// 						element: <ErrorPage />,
// 					},
// 				],
// 		},
// 	]
// }


/* eslint-disable prettier/prettier */
import { PATHS } from './_PATHS'
import { useTranslation } from 'react-i18next'
// import MainLayout from 'layout/MainLayout'
// import SubLayout from 'layout/SubLayout'
// import RoomPage from 'pages/RoomPage'
// import HomePage from 'pages/HomePage'
// import ShopPage from 'pages/ShopPage'
// import PrizePage from 'pages/PrizePage'
// import RankPage from 'pages/RankPage'
// import FriendPage from 'pages/FriendPage'
// import MorePage from 'pages/MorePage'
// import ProfilePage from 'pages/ProfilePage'
// import LoginPassMobile from 'pages/LoginPassMobile'
// import LoginOTPMobile from 'pages/LoginOTPMobile'
// import OTPConfirmMobile from 'pages/OTPConfirmMobile'
// import PlayRoomPage from 'pages/PlayRoomPage'
// import RoomPageLayout from 'layout/RoomPageLayout'
import { useMediaQuery, mediaQueryPoint } from 'utils/hooks'
// import LoginOTPModal from 'components/Modal/LoginOTPModal'
// import OTPConfirmModal from 'components/Modal/OTPConfirmModal'
// import MenuMobile from 'pages/ProfileMobile/MenuMobile'
// import UserInfoMobile from 'pages/ProfileMobile/UserInfoMobile'
// import SelectAvaMobile from 'pages/ProfileMobile/SelectAvaMobile'
// import GiftHistMobile from 'pages/ProfileMobile/GiftHistMobile'
// import InvitationMobile from 'pages/ProfileMobile/InvitationMobile'
// import IntroduceMobile from 'pages/ProfileMobile/IntroduceMobile'
// import ChangePassMobile from 'pages/ProfileMobile/ChangePassMobile'
// import SettingMobile from 'pages/ProfileMobile/SettingMobile'
// import ChangeInfoMobile from 'pages/ProfileMobile/ChangeInfoMobile'
// import ErrorPage from 'layout/ErrorPage'
// import MaintainPage from 'layout/MaintainPage'
// import FriendMobile from 'pages/FriendMobile'
import RankMobile from 'pages/RankMobile'
import { getUserinfo } from 'utils/localStorage'
import { Navigate, useLocation } from 'react-router-dom'
import React from 'react'
// import SettingPage from 'pages/SettingPage'
// import EventWater from 'pages/Event/EventWater'
// import ResultEventWater from 'pages/Event/ResultEventWater'
// import EventBoatRacing from 'pages/Event/EventBoatRacing'
// import ResultEventBoatRacing from 'pages/Event/ResultEventBoatRacing'
// import EventBunpimay from 'pages/Event/EventBunpimay'
// import EventBoatRacingT10 from 'pages/Event/EventBoatRacingT10'
// import HomeNew from 'pages/HomeNew'
// import RankPageNew from 'pages/RankPageNew'
// import PrizePageNew from 'pages/PrizePageNew'
// import ProfilePageNew from 'pages/ProfilePageNew'
// import UserInfo from 'pages/ProfilePageNew/components/UserInfo'
// import GiftHis from 'pages/ProfilePageNew/components/GiftHis'
// import Settings from 'pages/ProfilePageNew/components/Settings'
// import LuckySpin from 'pages/LuckySpin/LuckySpin'

const LuckySpin = React.lazy(() => import('pages/LuckySpin/LuckySpin'))
const Settings = React.lazy(() => import('pages/ProfilePageNew/components/Settings'))
const GiftHis = React.lazy(() => import('pages/ProfilePageNew/components/GiftHis'))
const UserInfo = React.lazy(() => import('pages/ProfilePageNew/components/UserInfo'))
const ProfilePageNew = React.lazy(() => import('pages/ProfilePageNew'))
const PrizePageNew = React.lazy(() => import('pages/PrizePageNew'))
const RankPageNew = React.lazy(() => import('pages/RankPageNew'))
const HomeNew = React.lazy(() => import('pages/HomeNew'))
const SettingPage = React.lazy(() => import('pages/SettingPage'))
const FriendMobile = React.lazy(() => import('pages/FriendMobile'))
const MaintainPage = React.lazy(() => import('layout/MaintainPage'))
const ErrorPage = React.lazy(() => import('layout/ErrorPage'))
const ChangeInfoMobile = React.lazy(() => import('pages/ProfileMobile/ChangeInfoMobile'))
const ChangePassMobile = React.lazy(() => import('pages/ProfileMobile/ChangePassMobile'))
const IntroduceMobile = React.lazy(() => import('pages/ProfileMobile/IntroduceMobile'))
const InvitationMobile = React.lazy(() => import('pages/ProfileMobile/InvitationMobile'))
const SelectAvaMobile = React.lazy(() => import('pages/ProfileMobile/SelectAvaMobile'))
const SubLayout = React.lazy(() => import('layout/SubLayout'))
const RoomPage = React.lazy(() => import('pages/RoomPage'))
const LoginPassMobile = React.lazy(() => import('pages/LoginPassMobile'))
const PlayRoomPage = React.lazy(() => import('pages/PlayRoomPage'))
const RoomPageLayout = React.lazy(() => import('layout/RoomPageLayout'))
const FriendPage = React.lazy(() => import('pages/FriendPage'))
const MorePage = React.lazy(() => import('pages/MorePage'))
const LoginOTPMobile = React.lazy(() => import('pages/LoginOTPMobile'))
const OTPConfirmMobile = React.lazy(() => import('pages/OTPConfirmMobile'))
const LoginOTPModal = React.lazy(() => import('components/Modal/LoginOTPModal'))
const OTPConfirmModal = React.lazy(() => import('components/Modal/OTPConfirmModal'))


const RequireAuth = ({ children }) => {
	const userInfo = getUserinfo();
	const location = useLocation();
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
	return userInfo ? (
		children
	) : (
		<Navigate to={isMobileMD ? PATHS.LOGIN_PASS_MOBILE : PATHS.HOME_PAGE} replace state={{ path: location.pathname }}></Navigate>
	)
}

export function RouteList() {
	const { t } = useTranslation()
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)

	// TODO: Router transition animation

	return [
		{
			element: <SubLayout />,
			children:
				[
					// { path: PATHS.HOME_PAGE, element: <HomePage /> },
					{ path: PATHS.HOME_PAGE, element: <HomeNew /> },
					// { path: PATHS.EVENT_WATER_PAGE, element: <EventWater /> },
					// { path: PATHS.RESULT_EVENT_WATER_PAGE, element: <ResultEventWater /> },
					// { path: PATHS.EVENT_BOAT_RACING_PAGE, element: <EventBoatRacing /> },
					// { path: PATHS.RESULT_EVENT_BOAT_RACING_PAGE, element: <ResultEventBoatRacing /> },
					// { path: PATHS.BUNPIMAY_PAGE_HOME, element: <EventBunpimay /> },
					// { path: PATHS.SHOP_PAGE, element: <ShopPage /> },
					// { path: PATHS.PRIZE_PAGE, element: <PrizePage /> },
					{ path: PATHS.PRIZE_PAGE, element: <PrizePageNew /> },
					// { path: PATHS.RANK_PAGE, element: isMobileMD ? <RankMobile /> : <RankPage /> },
					{ path: PATHS.RANK_PAGE, element: <RankPageNew /> },
					{ path: PATHS.LUCKY_SPIN, element: <LuckySpin /> },
					...[isMobileMD ? {} : { path: PATHS.FRIEND_PAGE, element: <RequireAuth><FriendPage /></RequireAuth> }],
					{ path: PATHS.MORE_PAGE, element: <MorePage /> },
					{ element: <LoginOTPModal /> },
					{ element: <OTPConfirmModal /> },
					// { path: PATHS.EVENT_BOAT_RACING_PAGE_T10, element: <EventBoatRacingT10 /> },
					{
						element: <RoomPageLayout />,
						children: [
							...[
								isMobileMD
									? {}
									: {
										path: PATHS.ROOM_PAGE,
										element: <RoomPage />,
									},
								isMobileMD
									? {}
									: {
										path: PATHS.PLAYROOM_PAGE,
										element: <PlayRoomPage />,
									},
							],
						],
					},
					{
						path: PATHS.PROFILE_PAGE,
						// element: isMobileMD ? <RequireAuth><MenuMobile /></RequireAuth> : <RequireAuth><ProfilePage /></RequireAuth>,
						element: isMobileMD ? <RequireAuth><ProfilePageNew /></RequireAuth> : <RequireAuth><ProfilePageNew /></RequireAuth>,

					},
					{
						path: PATHS.MAINTAIN_PAGE,
						element: <MaintainPage />,
					},
					{
						path: PATHS.UNDEFINED_PAGE,
						element: <ErrorPage />,
					},
					{
						path: PATHS.SETTING_PAGE,
						element: <SettingPage />,
					},

				],
		},
		{
			element: <SubLayout />,
			children:
				[
					{
						path: PATHS.LOGIN_PASS_MOBILE,
						element: <LoginPassMobile title={t('modal.login.title')} />,
					},
					{
						path: PATHS.LOGIN_OTP_MOBILE,
						element: <LoginOTPMobile title={t('modal.login.title_OTP')} />,
					},
					{
						path: PATHS.OTP_MOBILE,
						element: <OTPConfirmMobile title={t('modal.login.title_OTP')} />,
					},
					{
						element: <RoomPageLayout />,
						children: [
							{
								path: PATHS.ROOM_PAGE,
								element: <RoomPage />,
							},
							{
								path: PATHS.PLAYROOM_PAGE,
								element: <PlayRoomPage title={t('room.playroom.title')} />,
							},
						],
					},
					{
						path: PATHS.MY_ACCOUNT,
						element: <RequireAuth><UserInfo title={t('mobile.my_acc.title')} /></RequireAuth>,
					},
					{
						path: PATHS.SELECT_AVA,
						element: <RequireAuth><SelectAvaMobile title={t('mobile.select_ava')} /></RequireAuth>,
					},
					{
						path: PATHS.GIFT_HIST,
						element: <RequireAuth><GiftHis title={t('mobile.gift_hist.title')} /></RequireAuth>,
					},
					{
						path: PATHS.INVITATION,
						element: <RequireAuth><InvitationMobile title={t('mobile.invitation.title')} /></RequireAuth>,
					},
					{
						path: PATHS.INTRODUCE,
						element: <RequireAuth><IntroduceMobile title={t('mobile.introduce')} /></RequireAuth>,
					},
					{
						path: PATHS.CHANGE_PASS,
						element: <RequireAuth><ChangePassMobile title={t('mobile.change_pass.title')} /></RequireAuth>,
					},
					{
						path: PATHS.SETTING,
						element: <RequireAuth><Settings title={t('mobile.setting.title')} /></RequireAuth>,
					},
					{
						path: PATHS.CHANGE_INFO,
						element: <RequireAuth><ChangeInfoMobile title={t('mobile.change_info.title')} /></RequireAuth>,
					},
					{ path: PATHS.FRIEND_PAGE, element: <RequireAuth><FriendMobile title={t('friendpage.friend')} /></RequireAuth> },
					{
						path: PATHS.MAINTAIN_PAGE,
						element: <MaintainPage />,
					},
					{
						path: PATHS.UNDEFINED_PAGE,
						element: <ErrorPage />,
					},
				],
		},
	]
}
